import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=e7237a98"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=e7237a98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports